



import {Component, Vue} from 'vue-property-decorator';
import {eventBusService} from "@/services";
import {EventBusModalType, EventBusToastType} from "@/share";

import MemoModalContainer from "@/components/Organisms/MemoModalContainer/MemoModalContainer.vue";

@Component({
  components: {MemoModalContainer}
})
export default class App extends Vue {
  public modalMessage = "Primary modals message!";
  public modalVisible = false;
  public modalHiddenCallback: any = () => ({})
  public modalOKCallback: any = () => ({})

  public created(): void {
    eventBusService.$on(
      eventBusService.EVENT_SHOW_MODAL,
      (data: EventBusModalType) => this.showModal(data)
    )

    eventBusService.$on(eventBusService.EVENT_SHOW_TOAST_INFO,
      (data: EventBusToastType) => this.showToastInfo(data)
    )

    eventBusService.$on(eventBusService.EVENT_SHOW_TOAST_SUCCESS,
      (data: EventBusToastType) => this.showToastSuccess(data)
    )

    eventBusService.$on(eventBusService.EVENT_SHOW_TOAST_ERROR,
      (data: EventBusToastType) => this.showToastError(data)
    )
  }

  private showModal(data: EventBusModalType): void {
    const {message, hiddenCallback, okCallback} = data

    if (!message) return

    this.modalMessage = message || ''

    if (hiddenCallback) this.modalHiddenCallback = hiddenCallback
    if (okCallback) this.modalOKCallback = okCallback

    this.modalVisible = true
  }

  private showToastInfo(data: EventBusToastType): void {
    const {title, message} = data
    this.$bvToast.toast(this.$tc(message || ''), {
      title: title || this.$tc('toast.info.title').toString(),
      toaster: "b-toaster-bottom-right",
      variant: "info",
      autoHideDelay: 5000
    });
  }

  private showToastSuccess(data: EventBusToastType): void {
    const {title, message} = data
    this.$bvToast.toast(this.$tc(message || ''), {
      title: title || this.$tc('toast.success.title').toString(),
      toaster: "b-toaster-bottom-right",
      variant: "success",
      autoHideDelay: 5000
    });
  }

  private showToastError(data: EventBusToastType): void {
    const {title, message} = data
    this.$bvToast.toast(this.$tc(message || ''), {
      title: title || this.$tc('toast.error.title').toString(),
      toaster: "b-toaster-bottom-right",
      variant: "danger",
      autoHideDelay: 5000
    });
  }
}
